import style from "./information.module.css";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { configAction } from "../../store/config/slice";
import { GameStep } from "../../types/config";
const Information = () => {
  const dispatch = useAppDispatch();
  // const information = useAppSelector((state) => state.awards.information);
  const handleLuckyUser = function () {
    dispatch(configAction.setGameStep(GameStep.LUCKYUER));
  };
  const luckyUsrer = useAppSelector(
    (state) => state.luckuUsers.luckyUsers.data?.data
  );

  return (
    <button
      onClick={() => {
        handleLuckyUser();
      }}
      style={{
        width: "100%",
        marginBottom: 16,
      }}
    >
      <div className={style.title}>
        <span
          style={{
            color: "#FCFAEE",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 600,
          }}
        >
          برندگان کد ٪۱۰۰ تا الان:
        </span>
        <span
          style={{
            color: "#FAE452",
            fontSize: 32,
            fontStyle: "normal",
            fontWeight: 725,
            marginRight: 4,
            marginLeft: 2,
          }}
        >
          {luckyUsrer?.total_hundred_percent_winners.toLocaleString()}
        </span>
        <span
          style={{
            color: "#FCFAEE",
            fontSize: 16,
            fontStyle: "normal",
            fontWeight: 600,
          }}
        >
          نفر
        </span>
        <img
          className={style.arrow}
          src={`${process.env.PUBLIC_URL}/assets/icon/arrow-left.svg`}
          alt="arrow-left"
        />
      </div>
    </button>
  );
};

export default Information;
